import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({

  Email: Yup.string()
    .email(() => i18n.t('common:validation.emailInvalid')),

});

export default schema;
